export enum CoaEnum {
  INCOME = "INCOME",
  COST_OF_SALES = "COST OF SALES",
  NET_PROFIT = "NET PROFIT",
  NET_ASSETS = "NET ASSETS",
  EXPENSES = "EXPENSES",
  DEPRECIATION_ASSETS = "DEPRECIATION ASSETS",
  DEPRECIATION_EXPENSE = "DEPRECIATION EXPENSE",
  DEPRECIATION_GOODS = "DEPRECIATION GOODS",
  OTHER_EXPENSES = "OTHER EXPENSES",
  AMORTISASI = "AMORTISASI",
  OTHER_INCOME = "OTHER INCOME",
  OPERATING_EXPENSES = "OPERATING EXPENSES",
  INCOME_TAX = "INCOME TAX",
  INCOME_TAX_EXPENSES = "INCOME TAX EXPENSES"
}